import type { Ref } from 'react';
import { Input as AntdInput, ConfigProvider, InputProps } from 'antd';
import cx from 'classnames';

export const Input = ({
  className,
  ...props
}: InputProps & {
  ref?: Ref<any> | undefined;
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            borderRadius: 100,
            borderRadiusSM: 100,
            borderRadiusLG: 100,
          },
        },
      }}
    >
      <AntdInput className={cx('h-[40px] sm:h-auto', className)} {...props} />
    </ConfigProvider>
  );
};

export const InputPassword = ({
  className,
  ...props
}: InputProps & {
  ref?: Ref<any> | undefined;
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            borderRadius: 100,
            borderRadiusSM: 100,
            borderRadiusLG: 100,
          },
        },
      }}
    >
      <AntdInput.Password className={cx('h-[40px] sm:h-auto', className)} {...props} />
    </ConfigProvider>
  );
};
